import { setPage } from "./Reducer";
import OrderRepository from "../../../repositories/OrderRepository";

const getPage = async (store, { page }) => {
  store.dispatch(setPage(page));
};

const createNewChat = async (customerId) => {
  if (!customerId) return;
  try {
    const { data } = await OrderRepository.createChatToCustomer({
      customerId,
    });
    return data?.id ?? null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const Action = {
  getPage,
  createNewChat,
};

export default Action;
